import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { ISoftwareSettingsRepository } from "@domain/repositories";
import { SettingsTypeEnumSchema } from "@domain/schemas/BI";

@injectable()
class DeleteSoftwareSettingsService {
    @inject(TYPES.ISoftwareSettingsRepository)
    private _softwareSettingsRepository!: ISoftwareSettingsRepository;

    async executeAsync(fileName: string, settingsType: SettingsTypeEnumSchema): Promise<boolean> {
        return this._softwareSettingsRepository.deleteAsync(fileName, settingsType);
    }
}
export { DeleteSoftwareSettingsService };
